import PlayButton from '../../src/legacy/PlayButton.tsx';
export default PlayButton;
